<template>
  <ModalStep
    id="mentee-matching-confirmation"
    data-test-id="matching-popup-title-confirmation"
    :header="{
      title: t('matching.newMatchingModal.confirmation.title'),
    }"
  >
    <template #headerBeforeElement>
      <ProgramReminder :programId="selectedProgramIdRef" />
    </template>

    <template #bodyContent>
      <MatchingSuggestionsSlider :mentors="mentorsSuggestionsRef" />
    </template>

    <template #footer>
      <div class="c-btns-container c-btn-center">
        <CustomButton
          usage="button"
          type="submit"
          data-test-id="matching-popup-restart-research"
          color="secondary"
          :text="t('matching.newMatchingModal.confirmation.button.change')"
          @emit:click="cancelMatch"
        >
          <template #icon>
            <ChangeIcon color="primary" />
          </template>
        </CustomButton>
      </div>
    </template>
  </ModalStep>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import MatchingSuggestionsSlider from '@/features/matching/components/matching-modals/mentee-matching-modal/mentee-matching-confirmation/matching-suggestions-slider/matching-suggestions-slider.vue'
import ProgramReminder from '@/features/programs/components/program-reminder/program-reminder.vue'
import { selectGetSelectedProgramId } from '@/features/programs/stores/programs/programs.selectors'
import programsStore from '@/features/programs/stores/programs/programs.store'
import CustomButton from '@/features/ui/components/button/custom-button.vue'
import ChangeIcon from '@/features/ui/components/icons/change-icon.vue'
import ModalStep from '@/features/ui/components/modal/modal-step/modal-step.vue'
import { selectGetMenteeMatchingModal } from '@/features/ui/store/modal/modal.selectors'
import type { MenteeMatchingModalType } from '@/features/ui/store/modal/modal.store'
import modalsStore from '@/features/ui/store/modal/modal.store'
import useToast from '@/hooks/use-toasts.hook'
import { useI18n } from '@/lib/i18n'
import { ANALYTICS_EVENTS, trackEvent } from '@/lib/posthog'

const selectedProgramIdRef = selectGetSelectedProgramId(programsStore)

const menteeMatchingModalRef = selectGetMenteeMatchingModal(modalsStore)
const mentorsSuggestionsRef = computed(() => menteeMatchingModalRef.value?.attachedData.mentors || [])

const toast = useToast()
const { t } = useI18n()

// cancel the match and go back to the goal reminder
function cancelMatch() {
  trackEvent(ANALYTICS_EVENTS.MATCHING_SEARCH_RESTART, {
    program_id: selectedProgramIdRef.value,
    role: 'mentee',
    results_count: mentorsSuggestionsRef.value.length,
  })

  modalsStore.setModalStep<MenteeMatchingModalType>('mentee-matching', 'fill-criteria')
  modalsStore.updateModalAttachedData<MenteeMatchingModalType>('mentee-matching', {
    mentors: [],
  })
  toast?.error(t('matching.newMatchingModal.confirmation.cancel'))
}
</script>

<style lang="scss">
@import './mentee-matching-confirmation.scss';
</style>
